import React, { useContext, useEffect, useState } from "react";
import { CircularProgress, makeStyles } from "@material-ui/core";
import DialogAcerBrag from "../../components/UI/DialogAcerBrag";
import LimitedBackdrop from "../../components/UI/LimitedBackdrop";
import { separations } from "../../constants/StyleConstants";
import QualityCertificateRequestsAPI from "../../services/QualityCertificateRequestsAPI";
import { LoginContext } from "../../contexts/LoginContext";
import { AppContext } from "../../contexts/AppContext";
import MaterialTable from 'material-table';
import { defaultGridOptions, tooltipDelay, useGridColDefs } from '../../utils/GridUtils';

const useStyles = makeStyles((theme) => ({
  ...separations,
  root: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    flexDirection: "column",
    rowGap: ".4em",
  },
  serviceSheetsHeader: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    fontWeight: "bold",
    width: "100%",
    marginBottom: ".5em",
    padding: "0 .7em 0 .7em",
  },
  serviceSheets: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    width: "100%",
    backgroundColor: "rgba(0,0,0,.2)",
    padding: ".3em .8em .3em .8em",
    borderRadius: "4px",
    border: "1px solid rgba(0,0,0,.2)",
  },
}));

const QualityCertificateRequestModifyModal = ({
  open,
  setOpen,
  selectedRows,
  setSelectedRows,
  reloadGrid,
  rows,
  loading,
  tableRef,
}) => {
  const classes = useStyles();
  const [openBackDrop, setOpenBackDrop] = useState(false);
  const { showError, showSuccess } = useContext(AppContext);
  const [ selected, setSelected ] = useState([]);

  const confirmRequires = () => {
    setOpenBackDrop(true);

    const selectedRowsfiltered  = selectedRows.filter(item => item.statusDescription === 'Gestionado').map(r => r.uploadCode)

     const request = Array.from(new Set(selectedRowsfiltered));
    return QualityCertificateRequestsAPI.deleteFile(request)
      .then((res) => {
        showSuccess("Los certificados se han rechazado con éxito");
        setSelectedRows([]);
        reloadGrid();
      })
      .catch((error) => {
        const errorMsg = "Error al rechazar los certificados";
        showError(errorMsg, error);
        //throw new Error(errorMsg);
      })
      .finally(() => {
        setOpen(false);
        setTimeout(() => setOpenBackDrop(false), 250);
      });
  };

  const selectedUpload = selectedRows.filter(item => item.statusDescription === 'Gestionado').map((row) => row.uploadCode);

  const search = () =>{

    const uploadCodes = selectedUpload;

    QualityCertificateRequestsAPI.searchByUploadCode(uploadCodes)
    .then((res) => {
      setSelected(res)
    })
    .catch((error) => {
      showError('No se pudo obtener los datos')
    })
  }

  useEffect(() => {
    open ? search() : setSelected([]);
  }, [open])


  const colDefs = useGridColDefs([
    { title: 'Fecha Ingreso', field: 'creationDate', valueType: 'date'},
    { title: 'Proveedor', field: 'cuit'},
    { title: 'Nro. de pedido de compra', field: 'purchaseOrderId' },
    { title: 'Cód. Material', field: 'materialCode', valueRender: (value) => value.replace(/^0+/, "")} ,
    { title: 'Entrega', field: 'delivery'},
    { title: 'Fecha Gestión', field: 'uploadDate', valueType: 'date'}
  ]);

  return (
    <DialogAcerBrag
      open={open}
      setOpen={setOpen}
      title="Lista de certificados a rechazar"
      action={confirmRequires}
      actionText="Rechazar"
    >
      <LimitedBackdrop open={openBackDrop}>
        <CircularProgress color="primary" />
      </LimitedBackdrop>
      <div className={classes.root}>
        <MaterialTable
          {...defaultGridOptions}
          options={{
            ...defaultGridOptions.options,
            pageSizeOptions: [...defaultGridOptions.options.pageSizeOptions, defaultGridOptions.options.pageSizeOptions.last() * 2],
            selection: false,
            headerSelectionProps: { color: 'primary'}, 
            selectionProps: rowData => {
              return {
                color: 'primary',
              };
            },
          }}
          //onSelectionChange={(rows, row) => setSelectedRows(rows)}
          columns={colDefs}
          data={selected.filter(item => item.statusDescription === 'Gestionado')}
          isLoading={loading}
          tableRef={tableRef}
        />
      </div>
    </DialogAcerBrag>
  );
};
export default QualityCertificateRequestModifyModal;
